import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './EditPost.css';
import API_URL from '../config';

const EditPost = ({ post, onClose, onPostUpdated }) => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    content: '',
    category: 'noticia',
    author: '',
    imageUrl: '',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (post) {
      setFormData({
        title: post.title,
        description: post.description,
        content: post.content,
        category: post.category,
        author: post.author,
        imageUrl: post.imageUrl || '',
      });
    }
  }, [post]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);

    if (!formData.title || !formData.description || !formData.content || !formData.author) {
      setError('Por favor completa todos los campos obligatorios');
      return;
    }

    try {
      setLoading(true);
      await axios.put(`${API_URL}/api/posts/${post._id}`, formData);

      setSuccess(true);
      setTimeout(() => {
        if (onPostUpdated) onPostUpdated();
        onClose();
      }, 1500);
    } catch (err) {
      setError('Error al actualizar el post. Intenta de nuevo.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="edit-post-overlay" onClick={onClose}>
      <div className="edit-post-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-icon" onClick={onClose}>×</button>

        <h1>Editar Post</h1>

        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">¡Post actualizado exitosamente!</div>}

        <form onSubmit={handleSubmit} className="edit-form">
          <div className="form-group">
            <label htmlFor="title">Título *</label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Ingresa el título del post"
              maxLength={150}
            />
            <small>{formData.title.length}/150</small>
          </div>

          <div className="form-group">
            <label htmlFor="description">Descripción *</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Escribe una descripción breve"
              maxLength={300}
              rows={3}
            />
            <small>{formData.description.length}/300</small>
          </div>

          <div className="form-group">
            <label htmlFor="content">Contenido *</label>
            <textarea
              id="content"
              name="content"
              value={formData.content}
              onChange={handleChange}
              placeholder="Escribe el contenido completo del post"
              rows={8}
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="category">Categoría *</label>
              <select
                id="category"
                name="category"
                value={formData.category}
                onChange={handleChange}
              >
                <option value="noticia">Noticia</option>
                <option value="opinión">Opinión</option>
                <option value="review-musical">Review Musical</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="author">Autor *</label>
              <input
                type="text"
                id="author"
                name="author"
                value={formData.author}
                onChange={handleChange}
                placeholder="Tu nombre"
                maxLength={50}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="imageUrl">URL de la imagen</label>
            <input
              type="url"
              id="imageUrl"
              name="imageUrl"
              value={formData.imageUrl}
              onChange={handleChange}
              placeholder="https://ejemplo.com/imagen.jpg"
            />
          </div>

          <div className="form-actions">
            <button type="button" onClick={onClose} className="cancel-btn">
              Cancelar
            </button>
            <button type="submit" disabled={loading} className="submit-btn">
              {loading ? 'Guardando...' : 'Guardar Cambios'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPost;